import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=28f6037c"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"
import style0 from "./Details.vue?vue&type=style&index=0&id=28f6037c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports